import { reactive } from "vue";

export function useTranslation({ setVoiceForLanguage }) {
    const state = reactive({
        isLoading: false,
        currentLang: "fr",
    });

    async function selectLang(targetLang) {
        state.currentLang = targetLang;
        setVoiceForLanguage(targetLang);
        state.isLoading = true;

        const getTextNodes = () => {
            const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
                acceptNode: (node) => {
                    if (!node.textContent.trim()) return NodeFilter.FILTER_REJECT;
                    let parent = node.parentElement;
                    if (!parent) return NodeFilter.FILTER_REJECT;
                    const invalidTags = ["SCRIPT", "STYLE", "NOSCRIPT", "IFRAME", "SVG", "CODE"];
                    if (parent.closest(invalidTags.join(","))) return NodeFilter.FILTER_REJECT;
                    return NodeFilter.FILTER_ACCEPT;
                },
            });
            const nodes = [];
            let currentNode;
            while ((currentNode = walker.nextNode())) {
                nodes.push(currentNode);
            }
            return nodes;
        };

        const textNodes = getTextNodes();

        textNodes.forEach((node) => {
            if (!node._tenjityOriginal) {
                node._tenjityOriginal = node.textContent;
            }
        });

        if (targetLang === "fr") {
            textNodes.forEach((node) => {
                if (node._tenjityOriginal) node.textContent = node._tenjityOriginal;
            });
            state.isLoading = false;
            return;
        }

        const textToNodeMap = new Map();
        textNodes.forEach((node) => {
            const text = node._tenjityOriginal ? node._tenjityOriginal.trim() : "";
            if (text.length > 0) {
                if (!textToNodeMap.has(text)) textToNodeMap.set(text, []);
                textToNodeMap.get(text).push(node);
            }
        });

        const uniqueTexts = Array.from(textToNodeMap.keys());
        const DELIMITER = "\n";
        const MAX_CHUNK_LENGTH = 1500;
        const chunks = [];
        let currentChunk = [];
        let currentLength = 0;

        for (const text of uniqueTexts) {
            const safeText = text.replace(/\n/g, " ");
            if (currentLength + safeText.length + DELIMITER.length > MAX_CHUNK_LENGTH) {
                chunks.push(currentChunk);
                currentChunk = [];
                currentLength = 0;
            }
            currentChunk.push(safeText);
            currentLength += safeText.length + DELIMITER.length;
        }
        if (currentChunk.length > 0) chunks.push(currentChunk);

        try {
            await Promise.all(
                chunks.map(async (textArray) => {
                    const sourceText = textArray.join(DELIMITER);
                    const gtxUrl = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=fr&tl=${targetLang}&dt=t&q=${encodeURIComponent(sourceText)}`;
                    const proxyUrl = `https://corsproxy.io/?` + encodeURIComponent(gtxUrl);

                    const response = await fetch(proxyUrl);
                    if (!response.ok) throw new Error("Translation request failed");

                    const data = await response.json();
                    const fullTranslatedKey = data[0].map((item) => item[0]).join("");
                    const distinctTranslations = fullTranslatedKey.split("\n");

                    textArray.forEach((originalText, index) => {
                        if (distinctTranslations[index]) {
                            const translatedText = distinctTranslations[index].trim();
                            const nodes = textToNodeMap.get(originalText);
                            if (nodes) nodes.forEach((node) => (node.textContent = translatedText));
                        }
                    });
                })
            );
        } catch (err) {
            console.error("Translation failed:", err);
        } finally {
            state.isLoading = false;
        }
    }

    return { state, selectLang };
}
